import { createNamespacedHelpers } from "vuex";
import axios from 'axios';

const state = {
  isLoading: false,
  state: 'none',
  all: [],
  department: {
    id: null,
    name: '',
  },
  departmentSelected: null
}

const mutations = {
  startLoadAll(state) {
    state.isLoading = true;
  },
  loadAllSuccess(state, payload) {
    state.all = payload;
    state.isLoading = false;
  },
  selectDepartment(state, department) {
    state.state = 'showing';
    state.departmentSelected = department;
  },
  reset(state) {
    state.state = state.department.id === null ? 'none' : 'showing';

    state.department.id = null;
    state.department.name = '';
  },
  startEdit(state, department) {
    state.department.id = department.id;
    state.department.name = department.name;
    
    state.state = 'editing';
  },
  updateName(state) {
    state.department.name = name;
  }
}

const actions = {
  async loadAllByArea({ commit }, { areaId, params }) {
    commit('startLoadAll');

    let response = await axios.get(`/api/areas/${areaId}/departments`, {
      params: params
    });

    commit('loadAllSuccess', response.data.data);
  }
}

export const {
  mapState: mapDepartmentsState,
  mapMutations: mapDepartmentsMutations,
  mapActions: mapDepartmentsActions,
} = createNamespacedHelpers('departments');

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
